import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'className()'
  }
})
export class SkeletonComponent {
  readonly isLoading = input<boolean>(true);
  readonly repeat = input<number>(1);
  readonly width = input<string | undefined>('100%');
  readonly height = input<string | undefined>('1.25rem');
  readonly className = input<string | undefined>('');
  readonly itemClassName = input<string | undefined>('');

  readonly skeletonConfigs = computed(() =>
    Array.from({ length: this.repeat() }).map(() => ({
      width: this.width(),
      height: this.height()
    }))
  );
}
